<template>
  <div id="UI"
       class="UI clickThrough" >

    <div id="top"
          style="background-color: white;"
          class="clickable">

      <v-container fluid >
        <v-row dense
                justify="start">
<!--          <v-col class="px-4">-->
<!--            <v-badge color="secondary" :content="filteredMetadataSize" />-->
<!--          </v-col>-->
          <v-col class="btn-container">
            <v-btn elevated :href="'https://gendib.wsl.ch/en/user-manual/'" target="_blank" class="user-manual-link full-size">
              <v-icon left :color="'#626262'">contact_support</v-icon>
              User Manual
            </v-btn>
          </v-col>
          <v-col>
            <v-switch label="Exclusive Filtering"
                      class="custom-font-style"
                      density="compact"
                      hide-details
                      color="primary"
                      v-model="exclusiveFiltering"
            />
          </v-col>
          <v-col>
            <v-switch label="Published Data"
                      class="custom-font-style"
                      density="compact"
                      hide-details
                      color="primary"
                      v-model="onlyPublishedData"
            />
          </v-col>
          <v-col>
            <v-switch label="Swiss Data Only"
                      class="custom-font-style"
                      density="compact"
                      hide-details
                      color="primary"
                      v-model="onlySwissData"
            />
          </v-col>
        </v-row>
        <v-row dense
               justify="space-between">

          <v-col v-for="(propertyKey, index) in filteredPropertyKeys"
                 :key="index"
                 style="overflow: hidden; white-space: nowrap; text-overflow: clip">
            <v-autocomplete :items="getFilterItems(propertyKey)"
                            :label="getDisplayName(propertyKey)"
                            @update:modelValue="addSelection(propertyKey, $event)"
                            clearable
                            :multiple="!exclusiveFiltering"
                            hide-details
                            single-line
                            class="custom-autocomplete">

              <!-- Custom selection slot -->
              <template v-slot:selection="{ item, index }">
                <!-- Only render the first selected item -->
                <span v-if="index === 0" class="custom-selection" :key="item.value">
                {{ item.value}}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

      </v-container>

    </div>

    <div id="UI" class="UI clickThrough">
      <div id="side" class="UI-mid">
        <div v-if="selectedMetadata" id="leftSide" class="metadata-container clickable">
          <MetadataView :metadata-object="selectedMetadata" @close="catchCloseClick" />
        </div>
      </div>
      <div id="clearEvent" style="pointer-events: none;" ></div>
    </div>


  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {getFilteringStringItem, getFilterItemKeyFromString} from "@/stores/filtering";
import {useMetadataStore} from "@/stores/metadataStore";
import MetadataView from "@/components/MetadataView.vue";

export default defineComponent({
  components: {MetadataView},
  setup() {

  },
  props: {
    filterPropertyKeys: Array<string>,
    filterMap: Map<string, FilterItem[]>,
  },
  emits: ['filterChange'],
  computed: {
    exclusiveFiltering: {
      get() {
        return this.mStore.exclusiveFiltering;
      },
      set(value: boolean) {
        this.mStore.changeExclusiveFiltering(value);
      },
    },
    onlySwissData: {
      get() {
        console.log('Getting onlySwissData:', this.mStore.showSwissDataOnly === 'yes');

        return this.mStore.showSwissDataOnly === 'yes';
      },
      set(value: boolean) {
        console.log('Setting onlySwissData:', value);

        this.mStore.showSwissDataOnly = value ? 'yes' : 'no';

        // Adjust propKey to be null when the toggle is off
        const filterItem = {
          filterKey: 'swiss_data',
          propKey: value ? ['yes'] : null, // Use null instead of ['no']
        };

        this.mStore.changeFilter(filterItem);
      },
    },
    onlyPublishedData: {
      get() {
        return this.mStore.showDataSetPublishedOnly === 'yes';
      },
      set(value: boolean) {
        this.mStore.showDataSetPublishedOnly = value ? 'yes' : 'no';

        // Adjust propKey to be null when the toggle is off
        const filterItem = {
          filterKey: 'data_set_published',
          propKey: value ? ['yes'] : null, // Use null instead of ['no']
        };

        this.mStore.changeFilter(filterItem);
      },
    },
    filteredPropertyKeys() {
      return this.mStore.filterPropertyKeys.filter(key => key !== 'swiss_data' && key !== 'data_set_published');
    },
    selectedMetadata() {
      return this.mStore.selectedMetadata ? this.mStore.selectedMetadata : null;
    },
    selectedMetadataValues(): string[] {
      return this.selectedMetadata ? Object.values(this.selectedMetadata) : [];
    },
    filteredMetadataSize() {
      return this.mStore.filteredFeatures.features.length;
    },
  },
  methods: {
    getFilterItems(propertyKey: string) {
      const filterItems = this.filterMap?.get(propertyKey);
      if (!filterItems) return [];

      const items = filterItems.map(item => getFilteringStringItem(item, this.exclusiveFiltering));
      return items.sort((a, b) => a.localeCompare(b));
    },
    addSelection(filterKey: string, newValue: string | readonly string[] | null) {
      let propKey: string[] | null = null;
      if (newValue) {
        propKey = getFilterItemKeyFromString(newValue, this.exclusiveFiltering);
      }
      this.$emit('filterChange', { filterKey, propKey });
    },
    catchCloseClick() {
      this.mStore.selectRecord('');
    },
    getDisplayName(propertyKey: string) {
      const nameMap = {
        'species_group': 'Species Group',
        'species_scientific': 'Species',
        'marker_types': 'Marker',
        'canton': 'Canton',
      };
      return nameMap[propertyKey as keyof typeof nameMap];
    },
  },
  data: () => ({
    mStore: useMetadataStore(),
  }),
})
</script>

<style scoped>
  .UI {
    height: 100%;
    width: 100%;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 136px auto;
    gap: 10px;
    padding: 10px;

    background-color: transparent;
  }

  .UI-mid {
    display: grid;
    grid-template-columns: 33% auto;
    grid-template-rows: 1fr;
    gap: 10px;
    height: 80%;
    pointer-events: none;
  }

  .clickable {
    pointer-events: auto;
  }

  .clickThrough {
    pointer-events: none;
  }

  .custom-font-style {
    font-family: 'Arial', sans-serif;
    font-weight: bold;
    color: #333;
  }

  .user-manual-link {
    text-transform: none;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
    color: #858585;
  }

  .btn-container {
    height: 70%;
    width: 50%;
    justify-content: center;
  }

  .full-size {
    height: 80%;
    width: 80%;
    justify-content: center;
  }

</style>
